import styled from "styled-components"
import {ReactComponent as Check} from "images/icons/check.svg"

export const Container = styled.div`
display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`

export const OperationContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 0.6rem;
  background: ${({ theme }) => theme.colors.white};
  padding: 2rem;
`
export const EmptyWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 2rem;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.greyDark};
`

export const CheckIcon = styled(Check)`
  height: 3.2rem;
  fill: ${({ theme }) => theme.colors.grey};
  margin-right: 1rem;
`
